import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-main-navbar',
  templateUrl: './main-navbar.component.html',
  styleUrls: ['./main-navbar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class MainNavbarComponent implements OnInit {
  @Input() wipperozLogo =
    'https://cdn.sanity.io/images/jizm7zxy/production/be216da9ba89e8e4e817902b0dcd565b380b5010-1516x583.png?fm=webp&q=60&w=200';
  @Input() navbarClass?: string;
  urlLogin = `${environment.appUrl}/auth/login`;
  urlSignUp = `${environment.appUrl}/auth/signup`;
  classApplied = false;
  helpLink = $localize`:@@helpIntercomLink:https://help.wipperoz.com/en/support/home`;

  aboutWipperozButtonAriaLabel = $localize`:@@aboutWipperozButtonAriaLabel:Open About Wipperoz Section`;
  suppliersButtonAriaLabel = $localize`:@@suppliersButtonAriaLabel:Open Suppliers Section`;
  termsButtonAriaLabel = $localize`:@@termsButtonAriaLabel:Open Terms and Conditions Section`;
  privacyButtonAriaLabel = $localize`:@@privacyButtonAriaLabel:Open Privacy Policy Section`;

  constructor() {}

  ngOnInit(): void {}

  toggleClass() {
    this.classApplied = !this.classApplied;
  }
}
